/** Where the cell pop-ups go, by screen size (see PopoverShell). */

/** Below this window width the pop-ups are bottom sheets. */
export const SHEET_MAX_WIDTH = 768;

/** Whether the pop-ups are bottom sheets at this window width (their content sizes itself for a finger then). */
export const isNarrow = () => typeof window !== 'undefined' && window.innerWidth < SHEET_MAX_WIDTH;

/** Keep a box of `size` at `pos` inside the viewport, `margin` from every edge (a box bigger than the viewport
 *  is pinned to the top-left margin). */
export function clampToViewport(
  pos: { left: number; top: number },
  size: { width: number; height: number },
  viewport: { width: number; height: number },
  margin: number,
): { left: number; top: number } {
  const clamp = (v: number, max: number) => Math.max(margin, Math.min(v, max));
  return {
    left: clamp(pos.left, viewport.width - size.width - margin),
    top: clamp(pos.top, viewport.height - size.height - margin),
  };
}

/** "1145" as the pop-ups print it: "11:45". */
export function fmtHhmm(hhmm: string): string {
  return `${hhmm.slice(0, 2)}:${hhmm.slice(2)}`;
}
